import { render, staticRenderFns } from "./VerPdfDirectorArea.vue?vue&type=template&id=6fb531a8&scoped=true"
import script from "./VerPdfDirectorArea.vue?vue&type=script&lang=js"
export * from "./VerPdfDirectorArea.vue?vue&type=script&lang=js"
import style0 from "./VerPdfDirectorArea.vue?vue&type=style&index=0&id=6fb531a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb531a8",
  null
  
)

export default component.exports